// src/lib/kinema/konva/interaction/KonvaHitTestProvider.ts
import Konva from 'konva';
import type { HitTestProvider, Rect } from '../../core/tools/types';

export class KonvaHitTestProvider implements HitTestProvider {
  constructor(private stage: Konva.Stage, private getNodeMap: () => Map<string, Konva.Node>) {}

  getLayerAtPoint(x: number, y: number): string | null {
    const intersection = this.stage.getIntersection({ x, y });
    if (!intersection) return null;

    // Walk up from the intersected node to find one with a layerId
    let node: Konva.Node | null = intersection;
    while (node) {
      const layerId = node.getAttr('layerId');
      if (layerId) return layerId;
      node = node.parent;
    }
    return null;
  }

  getLayersInRect(rect: Rect): string[] {
    const result: string[] = [];
    const nodeMap = this.getNodeMap();

    // Convert node bounds to canvas space (same space as the marquee rect)
    const scale = this.stage.scaleX() || 1;
    const stageX = this.stage.x();
    const stageY = this.stage.y();

    for (const [layerId, node] of nodeMap) {
      const box = node.getClientRect();
      // getClientRect returns absolute screen coords — convert to canvas space
      const canvasBox: Rect = {
        x: (box.x - stageX) / scale,
        y: (box.y - stageY) / scale,
        width: box.width / scale,
        height: box.height / scale,
      };
      // Check if bounding boxes intersect
      if (
        canvasBox.x < rect.x + rect.width &&
        canvasBox.x + canvasBox.width > rect.x &&
        canvasBox.y < rect.y + rect.height &&
        canvasBox.y + canvasBox.height > rect.y
      ) {
        result.push(layerId);
      }
    }
    return result;
  }
}
